<template>
  <div class="question-wrap">
    <div class="question-outer">
      <div class="countdown">
        <div class="countdown-inner">
          <van-circle
            :key="id || 0"
            v-model="countdownRate"
            :color="countdownRed ? '#D54941' : '#41BD00'"
            layer-color="#ebedf0"
            stroke-width="80"
            size="19.5vw"
            :clockwise="false"
          >
            <template #default>
              <div class="countdown-text">
                <span>剩余时间</span>
                <van-count-down
                  :style="{ color: countdownRed ? '#D54941' : '#222' }"
                  :time="countdown"
                  format="ss"
                  @finish="onFinish"
                  @change="onChange"
                />
              </div>
            </template>
          </van-circle>
        </div>
      </div>
      <div class="question-state">
        <div class="question-index">
          问题&nbsp;{{ num }}<span>/{{ sum }}</span>
        </div>
      </div>
      <div class="question-inner">
        <div class="question">
          {{ question }}
        </div>
        <div class="answers">
          <van-row
            type="flex"
            align="center"
            v-for="(value, key) in answers"
            :key="key"
            :class="['answer-item', computedClass(key)]"
            @click="handleSelected(key)"
          >
            <van-col span="3"></van-col>
            <van-col span="18" style="text-align: left">{{ value }}</van-col>
            <van-col span="3" style="text-align: center">
              <template>
                <img
                  v-if="computedClass(key) === 'true'"
                  class="judge-icon"
                  src="@/assets/img/right-icon.png"
                />
                <img
                  v-if="computedClass(key) === 'false'"
                  class="judge-icon"
                  src="@/assets/img/wrong-icon.png"
                />
              </template>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { showNetworkDialog } from "@/utils/tools";
export default {
  props: {
    id: {
      type: Number,
      require: true,
    },
    question: {
      type: String,
      require: true,
    },
    answers: {
      type: Array,
      require: true,
    },
    num: {
      type: Number,
      require: true,
    },
    sum: {
      type: Number,
      require: true,
    },
    qids: { type: Array, default: () => [] },
  },
  data() {
    return {
      // 倒计时计时器
      // timer: 0,
      // 倒计时
      countdown: 30000,
      // 选择或者倒计时为0时为true
      isStop: false,
      // 用户选择的答案
      selectAnswer: "",
      //正确答案
      rightAnswer: "",
      // 答题loading
      loading: false,

      answerMap: ["A", "B", "C", "D"],
      countdownRate: 0,
      countdownRed: false,
      timer: null,
    };
  },
  computed: {
    ...mapState("versus", [
      "gameStatus",
      "player1",
      "player2",
      "score1",
      "gameResult",
      "socket",
      "clientId",
      "questionList",
    ]),
  },
  watch: {
    id: {
      handler() {
        this.selectAnswer = "";
        this.isStop = false;
        this.loading = false;
      },
      immediate: false,
    },
  },
  mounted() {
    this.timer = setTimeout(() => {
      if (this.isStop && this.qids.includes(this.id)) {
        showNetworkDialog();
      }
    }, 35000);
  },
  methods: {
    ...mapActions("versus", [
      "initSocket",
      "sendMessage",
      "closeSocket",
      "reset",
      "updateQuestionSelectAnswer",
    ]),
    checkAnswer(optionValue) {
      // 答题锁，防止重复提交
      if (this.isStop) {
        return;
      }
      // 空题目拦截
      if (!this.question) return;
      this.isStop = true;
      // 更新题目选中答案到store
      const questionItem = this.questionList.find(
        (item) => item.id === this.id
      );
      if (questionItem) {
        questionItem.selectAnswer = optionValue == 5 ? "" : optionValue;
      }
      // 更新本地答题状态
      this.selectAnswer = optionValue == 5 ? "" : optionValue;
      this.selectLoading = true;
      this.loading = true;
      // 发送答案到服务端
      this.sendMessage({
        type: "answer",
        qid: this.id || 0,
        answer:
          optionValue == 5 ? "" : this.answerMap[Number(this.selectAnswer)],
      });
    },
    onFinish() {
      this.checkAnswer(5);
    },
    onChange(currentTime) {
      this.countdownRate = Math.round(
        ((currentTime.seconds * 1000) / this.countdown) * 100
      );
      if (currentTime.seconds <= 3) {
        this.countdownRed = true;
      } else {
        this.countdownRed = false;
      }
    },
    // 选择答案
    handleSelected(key) {
      this.checkAnswer(key);
    },
    computedClass(value) {
      if (value === this.selectAnswer) {
        if (this.score1?.qid === this.id) {
          if (this.score1?.result) {
            return "true";
          } else {
            return "false";
          }
        } else {
          return "selected";
        }
      } else {
        return "";
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>
<style lang="scss" scoped>
.question-wrap {
  padding: 8px;
  background: #179aef;
  border: 2px solid #000;
  border-radius: 10px;
  .question-outer {
    position: relative;
    padding-top: 39px;
    background: #fff;
    border-radius: 12px;
    .countdown {
      position: absolute;
      top: -60px;
      right: 0;
      left: 0;
      box-sizing: border-box;
      width: 90px;
      height: 90px;
      padding: 3px;
      margin: auto;
      text-align: center;
      background: #fed24c;
      border: 2px solid #004640;
      border-radius: 50%;
      .countdown-inner {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: #fff;
        border-radius: 50%;
      }
      .countdown-text {
        margin-top: 20px;
        font-size: 10px;
        font-weight: 600;
        .van-count-down {
          margin-top: 4px;
          font-size: 24px;
        }
      }
      // box-shadow: 0 2px 11px 0 rgba(249, 120, 30, 0.6);
    }
    .question-state {
      display: flex;
      align-items: center;
      padding: 0 20px;
      .question-type {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 54px;
        height: 23px;
        margin-right: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #fff;
        background: #9bd77c;
        border-radius: 4px;
      }
      .question-index {
        font-size: 16px;
        font-weight: 600;
        line-height: 23px;
        color: #333;
        span {
          font-size: 12px;
          font-weight: 500;
          color: #dcdcdc;
        }
      }
    }
    .question-inner {
      max-height: 484px;
      overflow: auto;
      .question {
        padding: 0 23px 23px;
        font-size: 17px;
        font-weight: bold;
        line-height: 24px;
        color: #140661;
        text-align: justify;
      }
      .answers {
        padding: 0 23px 20px;
        overflow-y: scroll;
        .answer-item {
          box-sizing: border-box;
          padding: 14px 18px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          color: #333;
          background-color: #fff;
          border: 2px solid #0f0f0f;
          border-radius: 26px;
          box-shadow: inset 0 -8px 0 0 #dadada;
          .judge-icon {
            width: 20px;
            height: 20px;
          }
          &.selected {
            background-color: #f5fef8;
            border: 2px solid $button-blue-color;
            border-bottom-width: 5px;
            box-shadow: none;
          }
          &.true {
            background-color: #f5fef8;
            border: 2px solid #1fb175;
            border-bottom-width: 5px;
            box-shadow: none;
          }
          &.false {
            background-color: #feeaeb;
            border: 2px solid #dd4c40;
            border-bottom-width: 5px;
            box-shadow: none;
          }
          // .van-icon {
          //   vertical-align: top;
          // }
        }
      }
    }
  }
}
</style>
